import classnames from 'classnames';
import { forwardRef } from 'react';

import styles from './block.module.scss';

interface Props {
  children?: React.ReactNode;
  className?: string;
  testId?: string;
  withSeparator?: boolean;
  isTab?: boolean;
  noPadding?: boolean;
  centered?: boolean;
  wide?: boolean;
}

export const Block = forwardRef<HTMLDivElement, Props>(
  (
    {
      children,
      className,
      testId,
      withSeparator = false,
      isTab = false,
      noPadding = false,
      centered = false,
      wide = false,
    },
    ref,
  ) => (
    <div
      ref={ref}
      className={classnames(
        styles.block,
        styles.bodyBlock,
        {
          [styles.withVerticalSeparator]: withSeparator,
          [styles.isInTab]: isTab,
          [styles.noPadding]: noPadding,
          [styles.centered]: centered,
          [styles.wide]: wide,
        },
        className,
      )}
      data-testid={testId}
    >
      {children}
    </div>
  ),
);

Block.displayName = 'Block';

interface PropsV2 {
  children: React.ReactNode;
  className?: string;
  withSeparator?: boolean;
  noPadding?: boolean;
}

export const BlockV2 = forwardRef<HTMLDivElement, PropsV2>(
  ({ children, withSeparator, className, noPadding, ...rest }, ref) => (
    <div
      ref={ref}
      className={classnames(styles.block, className, {
        [styles.withVerticalSeparator]: withSeparator,
        [styles.noPadding]: noPadding,
      })}
      {...rest}
    >
      {children}
    </div>
  ),
);

BlockV2.displayName = 'BlockV2';

interface NotBlockProps {
  children: React.ReactNode;
  className?: string;
  wide?: boolean;
}

export const NotABlock = forwardRef<HTMLDivElement, NotBlockProps>(
  ({ children, className, wide }, ref) => (
    <div
      ref={ref}
      className={classnames(styles.notBlock, className, {
        [styles.wide]: wide,
      })}
    >
      {children}
    </div>
  ),
);

NotABlock.displayName = 'NotABlock';
